<template>
  <div
    class="u-card"
    :class="[`u-card--theme-${theme}`]"
    @click="$emit('click')">
    <div class="u-card__image">
      <BaseAvatar
        :image="avatar"
        class="u-card__avatar" />
    </div>
    <div class="u-card__data">
      <div class="u-card__title"><slot name="name"></slot></div>
      <div class="u-card__info"><slot name="info"></slot></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCard",
  props: {
    avatar: {
      type: String,
    },
    theme: {
      type: String,
      default: "default", // block
    },
  },
};
</script>

<style lang="less" scoped>
.u-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: @radius-xl;
  box-shadow: @shadow-default;
  padding: 16px 18px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;

  .fz(14);

  &__avatar {
    box-shadow: @shadow-default;
  }

  &__image {
    flex-grow: 0;
    flex-shrink: 0;
    width: 40px;
    margin-right: 20px;
  }

  &__title {
    .fz(18);
    line-height: 24/18;
    font-weight: bold;
  }

  &__info {
    .fz(14);
    color: @meta-color;
  }

  &__data {
    flex-grow: 1;
  }

  &--theme-block {
    padding: 0;
    box-shadow: none;
    overflow: initial;
  }
}
</style>
